import exceljs from "exceljs";
import {saveAs} from "file-saver";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    mimeTypeMap, 
    MyDate, 
} from "src/components/common/functions";
//dataFrame => key, title
export default function Export({
    eportTitle, 
    data, 
    dataFrame,
    totalsRow, 
}){
    const user = useMyStore(state => state.user);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const exportFunc = () => {
        if(!data.length){
            window.alert("No data to export.");
            return;
        }
        setShowLoader(true);
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        const worksheet = workbook.addWorksheet("My Sheet", {views: [{showGridLines: false}]});
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 22.57;
        const rows = data.map(item => [
            ...dataFrame.map(elem => 
                elem.type === "date" && !item[elem.exportKey || elem.key]?"":
                item[elem.exportKey || elem.key] ?? ""
            )
        ])
        worksheet.addTable({
            name: "MyTable",
            ref: "A1",
            totalsRow: totalsRow || false,
            style: {
                showRowStripes: true,
            },
            columns: [
                ...dataFrame.map(elem => 
                    ({name: elem.title, filterButton: true})
                )
            ],
            rows: rows,
        });
        worksheet.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                // exclude row 1 - ---------
                if(cell.row === 1) return;
                //-------------------------
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.3)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
        worksheet.getRows(2, rows.length).forEach(row => {row.alignment = { vertical: "middle", horizontal: "center", wrapText: true }});
        worksheet.getColumn(24/*#*/).alignment = {"wrapText": true, vertical: "top", horizontal: "left"};
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), `${eportTitle} export ${(new MyDate()).s()}.xlsx`);
            setShowLoader(false);
        })
    }
    return (<button type = "button" className = "headerButton" onClick = {exportFunc}>
        Export
    </button>)
}